import React, { FC, ReactNode } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  return (
    <div
      className={`nc-SectionHero relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            {heading}
          </h2>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
          The first and most user-friendly smart
          phone application in South Sudan
          for booking unique lodgings is called
          Nile Booking. Without ever leaving the
          the comfort of your home, Nile Booking
          allows you to plan the ideal trip
          anywhere quickly and easily in the
          nation.
          </span>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
          Our innovative mobile program (app),
          enables customers to list, find, and
          book lodgings across the nation
          whenever and wherever they like.
          The software enables users to rent or
          lease properties listed for lease by
          hosts. Users can browse listings and
          make direct bookings using the
          booking capabilities.
          </span>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
          From hotel-style rooms to bunk beds to
          boats, it covers all the essential travel
          essentials. Nile booking increases your
          travel alternatives by expanding your
          options for places to stay.
          Our app has several features that make
          booking quickly and simply.
          </span>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
          Nilebooking offers a mobile app that
          addresses both of those issues by
          enabling users to find the best lodging
          options in the cities they are visiting
          and book them at the most competitive
          rates.
          </span>
          {!!btnText && <ButtonPrimary href="/login">{btnText}</ButtonPrimary>}
        </div>
        <div className="flex-grow">
          <img className="w-full" src={rightImg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
